<template>
  <div class="jumbotron">
    <div class="row">
      <h4>Basics</h4>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Business Name<span class="red-text" v-if="!getBusinessName">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="businessName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': businessNameInvalid}">
        <div class="invalid-feedback">
          Please enter a business name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Display Name</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="displayName" class="form-control form-control-md">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Address<span class="red-text" v-if="!getAddress">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="address"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': addressInvalid}">
        <div class="invalid-feedback">
          Please enter an address
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Address 2</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="addressTwo" class="form-control form-control-md">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">City<span class="red-text" v-if="!getCity">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="city"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': cityInvalid}">
        <div class="invalid-feedback">
          Please enter a city
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">State<span class="red-text" v-if="!getState">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="state"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': stateInvalid}">
        <div class="invalid-feedback">
          Please enter a valid state
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Zip Code<span class="red-text" v-if="!getZip">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="zip"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': zipInvalid}"
               maxlength="5">
        <div class="invalid-feedback">
          Please enter a valid zip code
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Sales Phone<span class="red-text" v-if="!getSalesPhoneNumber">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <vue-tel-input v-model="salesPhoneNumber"
                       :disabledFetchingCountry="true"
                       class="form-control form-control-md phone-number"
                       v-bind:class="{'is-invalid': salesPhoneNumberInvalid, 'border-red': salesPhoneNumberInvalid}"
                       :onlyCountries="['us']">
        </vue-tel-input>
        <div class="invalid-feedback">
          Please enter a valid phone number
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Sales Email<span class="red-text" v-if="!getSalesEmail">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="salesEmail"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': salesEmailInvalid}">
        <div class="invalid-feedback">
          Please enter a valid email address
        </div>
      </div>
    </div>
    <div class="row">
      <h4>Company Info</h4>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Service Type<span class="red-text" v-if="getServiceType.length === 0">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <div class="custom-control custom-checkbox d-inline">
          <input class="custom-control-input"
                 type="checkbox"
                 id="inlineCheckbox1"
                 value="residential"
                 v-model="serviceType"
                 v-bind:class="{'is-invalid': serviceTypeInvalid}">
          <label class="custom-control-label" for="inlineCheckbox1">Residential</label>
        </div>
        <div class="custom-control custom-checkbox d-inline">
          <input class="custom-control-input"
                 type="checkbox"
                 id="inlineCheckbox2"
                 value="commercial"
                 v-model="serviceType"
                 v-bind:class="{'is-invalid': serviceTypeInvalid}">
          <label class="custom-control-label" for="inlineCheckbox2">Commercial</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Year Established</p>
      </div>
      <div class="col-md-3 my-auto">
        <input v-model="yearEstablished"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': yearEstablishedInvalid}"
               maxlength="4">
        <div class="invalid-feedback">
          Please enter a valid year
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Languages Spoken</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="languagesSpoken" class="form-control form-control-md">
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 col-4 text-right my-auto">
        <p class="no-margin-bottom">License</p>
      </div>
      <div class="col-md-3 col-8 my-auto text-center">
        <p class="d-inline no-margin-bottom">No</p>
        <label class="switch no-margin-bottom">
          <input v-model="hasLicense" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline no-margin-bottom">Yes</p>
      </div>
      <div v-if="hasLicense" class="col-md-6 my-auto">
        <input v-model="licenseNumber" class="form-control form-control-md">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-4 text-right my-auto">
        <p class="no-margin-bottom">Insurance</p>
      </div>
      <div class="col-md-3 col-8 my-auto text-center">
        <p class="d-inline no-margin-bottom">No</p>
        <label class="switch no-margin-bottom">
          <input v-model="hasInsurance" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline no-margin-bottom">Yes</p>
      </div>
      <div v-if="hasInsurance" class="col-md-6 my-auto">
        <money class="form-control form-control-md" v-model="insuranceAmount" v-bind="money"></money>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Website<span class="red-text" v-if="!getWebsite">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="website"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': websiteInvalid}">
          <div class="invalid-feedback">
            Please enter a valid URL
          </div>
      </div>
    </div>
    <div class="row">
      <h4>Hours</h4>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Monday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openMonday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openMonday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openMonday" class="col-md-3 my-auto">
        <select v-model="mondayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openMonday && (mondayOpen !== '24 hours' && mondayOpen !== null && mondayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="mondayClosed" class="form-control">
          <option v-for="(time, index) in mondayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Tuesday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openTuesday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openTuesday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openTuesday" class="col-md-3 my-auto">
        <select v-model="tuesdayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openTuesday && (tuesdayOpen !== '24 hours' && tuesdayOpen !== null && tuesdayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="tuesdayClosed" class="form-control">
          <option v-for="(time, index) in tuesdayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Wednesday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openWednesday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openWednesday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openWednesday" class="col-md-3 my-auto">
        <select v-model="wednesdayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openWednesday && (wednesdayOpen !== '24 hours' && wednesdayOpen !== null && wednesdayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="wednesdayClosed" class="form-control">
          <option v-for="(time, index) in wednesdayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Thursday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openThursday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openThursday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openThursday" class="col-md-3 my-auto">
        <select v-model="thursdayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openThursday && (thursdayOpen !== '24 hours' && thursdayOpen !== null && thursdayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="thursdayClosed" class="form-control">
          <option v-for="(time, index) in thursdayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Friday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openFriday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openFriday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openFriday" class="col-md-3 my-auto">
        <select v-model="fridayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openFriday && (fridayOpen !== '24 hours' && fridayOpen !== null && fridayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="fridayClosed" class="form-control">
          <option v-for="(time, index) in fridayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Saturday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openSaturday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openSaturday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openSaturday" class="col-md-3 my-auto">
        <select v-model="saturdayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openSaturday && (saturdayOpen !== '24 hours' && saturdayOpen !== null && saturdayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="saturdayClosed" class="form-control">
          <option v-for="(time, index) in saturdayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row time-row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Sunday</p>
      </div>
      <div class="col-md-3 my-auto text-right">
        <label class="switch no-margin-bottom">
          <input v-model="openSunday" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p v-if="openSunday" class="d-inline no-margin-bottom">Open</p>
        <p v-else class="d-inline no-margin-bottom">Closed</p>
      </div>
      <div v-if="openSunday" class="col-md-3 my-auto">
        <select v-model="sundayOpen" class="form-control">
          <option v-for="(time, index) in hours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
      <div v-if="openSunday && (sundayOpen !== '24 hours' && sundayOpen !== null && sundayOpen !== 'By Appointment Only')" class="col-md-3 my-auto">
        <select v-model="sundayClosed" class="form-control">
          <option v-for="(time, index) in sundayClosedHours" v-bind:key='index'>{{ time }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <button v-if="complete" v-on:click="save" class="btn btn-primary">Save</button>
        <button v-else v-on:click="save" class="btn btn-primary">Save & Continue</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import isUrl from 'is-url'
import router from '../../../../../router/index.js'
import { Money } from 'v-money'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

const times = [
  'By Appointment Only',
  '24 hours',
  '12:00 am',
  '12:30 am',
  '1:00 am',
  '1:30 am',
  '2:00 am',
  '2:30 am',
  '3:00 am',
  '3:30 am',
  '4:00 am',
  '4:30 am',
  '5:00 am',
  '5:30 am',
  '6:00 am',
  '6:30 am',
  '7:00 am',
  '7:30 am',
  '8:00 am',
  '8:30 am',
  '9:00 am',
  '9:30 am',
  '10:00 am',
  '10:30 am',
  '11:00 am',
  '11:30 am',
  '12:00 pm',
  '12:30 pm',
  '1:00 pm',
  '1:30 pm',
  '2:00 pm',
  '2:30 pm',
  '3:00 pm',
  '3:30 pm',
  '4:00 pm',
  '4:30 pm',
  '5:00 pm',
  '5:30 pm',
  '6:00 pm',
  '6:30 pm',
  '7:00 pm',
  '7:30 pm',
  '8:00 pm',
  '8:30 pm',
  '9:00 pm',
  '9:30 pm',
  '10:00 pm',
  '10:30 pm',
  '11:00 pm',
  '11:30 pm'
]

export default {
  created () {
    this.complete = this.profileIsComplete.profileComplete
    if (this.insuranceAmount) this.hasInsurance = true
    if (this.licenseNumber) this.hasLicense = true
    if (this.mondayOpen) this.openMonday = true
    if (this.tuesdayOpen) this.openTuesday = true
    if (this.wednesdayOpen) this.openWednesday = true
    if (this.thursdayOpen) this.openThursday = true
    if (this.fridayOpen) this.openFriday = true
    if (this.saturdayOpen) this.openSaturday = true
    if (this.sundayOpen) this.openSunday = true
  },
  components: {
    Money,
    VueTelInput
  },
  data () {
    return {
      hours: times,
      openMonday: false,
      openTuesday: false,
      openWednesday: false,
      openThursday: false,
      openFriday: false,
      openSaturday: false,
      openSunday: false,
      hasInsurance: false,
      hasLicense: false,
      formInvalid: false,
      businessNameInvalid: false,
      addressInvalid: false,
      cityInvalid: false,
      stateInvalid: false,
      zipInvalid: false,
      salesPhoneNumberInvalid: false,
      salesEmailInvalid: false,
      serviceTypeInvalid: false,
      yearEstablishedInvalid: false,
      websiteInvalid: false,
      complete: false,
      showDismissibleAlert: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  watch: {
    hasInsurance: function (newValue, oldValue) {
      if (newValue === false) this.insuranceAmount = 0
    },
    hasLicense: function (newValue, oldValue) {
      if (newValue === false) this.licenseNumber = null
    },
    openMonday: function (newValue, oldValue) {
      if (newValue === false) {
        this.mondayOpen = null
        this.mondayClosed = null
      }
    },
    openTuesday: function (newValue, oldValue) {
      if (newValue === false) {
        this.tuesdayOpen = null
        this.tuesdayClosed = null
      }
    },
    openWednesday: function (newValue, oldValue) {
      if (newValue === false) {
        this.wednesdayOpen = null
        this.wednesdayClosed = null
      }
    },
    openThursday: function (newValue, oldValue) {
      if (newValue === false) {
        this.thursdayOpen = null
        this.thursdayClosed = null
      }
    },
    openFriday: function (newValue, oldValue) {
      if (newValue === false) {
        this.fridayOpen = null
        this.fridayClosed = null
      }
    },
    openSaturday: function (newValue, oldValue) {
      if (newValue === false) {
        this.saturdayOpen = null
        this.saturdayClosed = null
      }
    },
    openSunday: function (newValue, oldValue) {
      if (newValue === false) {
        this.sundayOpen = null
        this.sundayClosed = null
      }
    },

    mondayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.mondayClosed = null
    },
    tuesdayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.tuesdayClosed = null
    },
    wednesdayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.wednesdayClosed = null
    },
    thursdayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.thursdayClosed = null
    },
    fridayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.fridayClosed = null
    },
    saturdayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.saturdayClosed = null
    },
    sundayOpen: function (newValue, oldValue) {
      if (newValue === '24 hours') this.sundayClosed = null
    }
  },
  methods: {
    ...mapActions('business', [
      'syncData'
    ]),
    async save () {
      this.validate()
      if (this.formInvalid === false) {
        this.syncData()
        this.showDismissibleAlert = true
        if (!this.complete) {
          router.replace('/profile/business/details/services')
        }
      }
    },
    ...mapMutations('business', [
      'updateBusinessName',
      'updateDisplayName',
      'updateSSN',
      'updateAddress',
      'updateAddressTwo',
      'updateCity',
      'updateState',
      'updateZip',
      'updateSalesPhoneNumber',
      'updateSalesEmail',
      'updateServiceType',
      'updateYearEstablished',
      'updateLanguagesSpoken',
      'updateLicenseNumber',
      'updateInsuranceAmount',
      'updateWebsite',
      'updateTimes'
    ]),
    validate () {
      this.formInvalid = false

      if (!this.getBusinessName) {
        this.businessNameInvalid = true
        this.formInvalid = true
      } else {
        this.businessNameInvalid = false
      }

      if (!this.getAddress) {
        this.addressInvalid = true
        this.formInvalid = true
      } else {
        this.addressInvalid = false
      }

      if (!this.getCity) {
        this.cityInvalid = true
        this.formInvalid = true
      } else {
        this.cityInvalid = false
      }

      var stateRegex = /^(AL|Alabama|alabama|AK|Alaska|alaska|AZ|Arizona|arizona|AR|Arkansas|arkansas|CA|California|california|CO|Colorado|colorado|CT|Connecticut|connecticut|DE|Delaware|delaware|FL|Florida|florida|GA|Georgia|georgia|HI|Hawaii|hawaii|ID|Idaho|idaho|IL|Illinois|illinois|IN|Indiana|indiana|IA|Iowa|iowa|KS|Kansas|kansas|KY|Kentucky|kentucky|LA|Louisiana|louisiana|ME|Maine|maine|MD|Maryland|maryland|MA|Massachusetts|massachusetts|MI|Michigan|michigan|MN|Minnesota|minnesota|MS|Mississippi|mississippi|MO|Missouri|missouri|MT|Montana|montana|NE|Nebraska|nebraska|NV|Nevada|nevada|NH|New Hampshire|new hampshire|NJ|New Jersey|new jersey|NM|New Mexico|new mexico|NY|New York|new york|NC|North Carolina|new carolina|ND|North Dakota|north dakota|OH|Ohio|ohio|OK|Oklahoma|oklahoma|OR|Oregon|oregon|PA|Pennsylvania|pennsylvania|RI|Rhode Island|rhode island|SC|South Carolina|south carolina|SD|South Dakota|south dakota|TN|Tennessee|tennessee|TX|Texas|texas|UT|Utah|utah|VT|Vermont|vermont|VA|Virginia|virginia|WA|Washington|washington|WV|West Virginia|west virginia|WI|Wisconsin|wisconsin|WY|Wyoming|wyoming)$/
      if (!stateRegex.test(this.getState)) {
        this.stateInvalid = true
        this.formInvalid = true
      } else {
        this.stateInvalid = false
      }

      var zipRegex = /^\d{5}$/
      if (!zipRegex.test(this.getZip)) {
        this.zipInvalid = true
        this.formInvalid = true
      } else {
        this.zipInvalid = false
      }

      var salesPhoneNumberRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      if (!salesPhoneNumberRegex.test(this.getSalesPhoneNumber)) {
        this.salesPhoneNumberInvalid = true
        this.formInvalid = true
      } else {
        this.salesPhoneNumberInvalid = false
      }

      var salesEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!salesEmailRegex.test(this.getSalesEmail)) {
        this.salesEmailInvalid = true
        this.formInvalid = true
      } else {
        this.salesEmailInvalid = false
      }

      if (this.getServiceType.length === 0) {
        this.serviceTypeInvalid = true
        this.formInvalid = true
      } else {
        this.serviceTypeInvalid = false
      }

      var yearEstablishedRegex = /^$|^\d{4}$/
      var yearEstablishedTest = (this.getYearEstablished === null) ? '' : this.getYearEstablished
      if (!yearEstablishedRegex.test(yearEstablishedTest)) {
        this.yearEstablishedInvalid = true
        this.formInvalid = true
      } else {
        this.yearEstablishedInvalid = false
      }

      var testString
      if (this.getWebsite.substring(0, 4) === 'https') {
        testString = this.getWebsite
      } else {
        testString = 'http://' + this.getWebsite
      }

      if (isUrl(testString)) {
        this.websiteInvalid = false
      } else {
        this.websiteInvalid = true
        this.formInvalid = true
      }
    }
  },
  computed: {
    ...mapGetters('business', [
      'profileIsComplete',
      'getBusinessName',
      'getDisplayName',
      'getSSN',
      'getAddress',
      'getAddressTwo',
      'getCity',
      'getState',
      'getZip',
      'getSalesPhoneNumber',
      'getSalesEmail',
      'getServiceType',
      'getYearEstablished',
      'getLanguagesSpoken',
      'getLicenseNumber',
      'getInsuranceAmount',
      'getWebsite',
      'getTimes'
    ]),
    mondayClosedHours () {
      var index = times.indexOf(this.mondayOpen)
      return times.slice(index + 1)
    },
    tuesdayClosedHours () {
      var index = times.indexOf(this.tuesdayOpen)
      return times.slice(index + 1)
    },
    wednesdayClosedHours () {
      var index = times.indexOf(this.wednesdayOpen)
      return times.slice(index + 1)
    },
    thursdayClosedHours () {
      var index = times.indexOf(this.thursdayOpen)
      return times.slice(index + 1)
    },
    fridayClosedHours () {
      var index = times.indexOf(this.fridayOpen)
      return times.slice(index + 1)
    },
    saturdayClosedHours () {
      var index = times.indexOf(this.saturdayOpen)
      return times.slice(index + 1)
    },
    sundayClosedHours () {
      var index = times.indexOf(this.sundayOpen)
      return times.slice(index + 1)
    },

    businessName: {
      get () {
        return this.getBusinessName
      },
      set (value) {
        this.updateBusinessName(value)
      }
    },
    displayName: {
      get () {
        return this.getDisplayName
      },
      set (value) {
        this.updateDisplayName(value)
      }
    },
    ssn: {
      get () {
        return this.getSSN
      },
      set (value) {
        this.updateSSN(value)
      }
    },
    address: {
      get () {
        return this.getAddress
      },
      set (value) {
        this.updateAddress(value)
      }
    },
    addressTwo: {
      get () {
        return this.getAddressTwo
      },
      set (value) {
        this.updateAddressTwo(value)
      }
    },
    city: {
      get () {
        return this.getCity
      },
      set (value) {
        this.updateCity(value)
      }
    },
    state: {
      get () {
        return this.getState
      },
      set (value) {
        this.updateState(value)
      }
    },
    zip: {
      get () {
        return this.getZip
      },
      set (value) {
        this.updateZip(value)
      }
    },
    salesPhoneNumber: {
      get () {
        return this.getSalesPhoneNumber
      },
      set (value) {
        this.updateSalesPhoneNumber(value)
      }
    },
    salesEmail: {
      get () {
        return this.getSalesEmail
      },
      set (value) {
        this.updateSalesEmail(value)
      }
    },
    serviceType: {
      get () {
        return this.getServiceType
      },
      set (value) {
        this.updateServiceType(value)
      }
    },
    yearEstablished: {
      get () {
        return this.getYearEstablished
      },
      set (value) {
        this.updateYearEstablished(value)
      }
    },
    languagesSpoken: {
      get () {
        return this.getLanguagesSpoken
      },
      set (value) {
        this.updateLanguagesSpoken(value)
      }
    },
    licenseNumber: {
      get () {
        return this.getLicenseNumber
      },
      set (value) {
        this.updateLicenseNumber(value)
      }
    },
    insuranceAmount: {
      get () {
        return this.getInsuranceAmount
      },
      set (value) {
        this.updateInsuranceAmount(Number(value))
      }
    },
    website: {
      get () {
        return this.getWebsite
      },
      set (value) {
        this.updateWebsite(value)
      }
    },
    mondayOpen: {
      get () {
        return this.getTimes.monday.open
      },
      set (value) {
        this.updateTimes({monday: {open: value}})
      }
    },
    mondayClosed: {
      get () {
        return this.getTimes.monday.closed
      },
      set (value) {
        this.updateTimes({monday: {closed: value}})
      }
    },
    tuesdayOpen: {
      get () {
        return this.getTimes.tuesday.open
      },
      set (value) {
        this.updateTimes({tuesday: {open: value}})
      }
    },
    tuesdayClosed: {
      get () {
        return this.getTimes.tuesday.closed
      },
      set (value) {
        this.updateTimes({tuesday: {closed: value}})
      }
    },
    wednesdayOpen: {
      get () {
        return this.getTimes.wednesday.open
      },
      set (value) {
        this.updateTimes({wednesday: {open: value}})
      }
    },
    wednesdayClosed: {
      get () {
        return this.getTimes.wednesday.closed
      },
      set (value) {
        this.updateTimes({wednesday: {closed: value}})
      }
    },
    thursdayOpen: {
      get () {
        return this.getTimes.thursday.open
      },
      set (value) {
        this.updateTimes({thursday: {open: value}})
      }
    },
    thursdayClosed: {
      get () {
        return this.getTimes.thursday.closed
      },
      set (value) {
        this.updateTimes({thursday: {closed: value}})
      }
    },
    fridayOpen: {
      get () {
        return this.getTimes.friday.open
      },
      set (value) {
        this.updateTimes({friday: {open: value}})
      }
    },
    fridayClosed: {
      get () {
        return this.getTimes.friday.closed
      },
      set (value) {
        this.updateTimes({friday: {closed: value}})
      }
    },
    saturdayOpen: {
      get () {
        return this.getTimes.saturday.open
      },
      set (value) {
        this.updateTimes({saturday: {open: value}})
      }
    },
    saturdayClosed: {
      get () {
        return this.getTimes.saturday.closed
      },
      set (value) {
        this.updateTimes({saturday: {closed: value}})
      }
    },
    sundayOpen: {
      get () {
        return this.getTimes.sunday.open
      },
      set (value) {
        this.updateTimes({sunday: {open: value}})
      }
    },
    sundayClosed: {
      get () {
        return this.getTimes.sunday.closed
      },
      set (value) {
        this.updateTimes({sunday: {closed: value}})
      }
    }
  }
}
</script>

<style scoped>
.custom-checkbox {
  padding-right: 2rem;
}

.phone-number >>> input {
  color: #495057;
}

.border-red {
  border-color: red;
}

.border-red:focus-within {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.time-row {
  padding-bottom: .4rem;
}

.insurance-input {
  border-radius: 0px 12px 12px 0px !important;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.needs-margin-right {
  margin-left: .75rem;
}

@media (max-width: 768px) {
  .needs-margin {
    margin-top: .25rem;
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FEEDAA;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch-wrapper {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/details/details/Overview.vue